import React, {
  createContext,
  useState,
  useContext,
  useEffect,
  useMemo,
} from "react";
import {
  getDefaultCompanyUuid,
  setDefaultCompanyUuid,
} from "./lib/persistence";
import { getCompany, getCompanyRole } from "./api/company";

const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  const defaultCompany = getDefaultCompanyUuid();
  const initialState = {
    selectedCompany: {},
    selectedCompanyRole: null,
  };
  const [state, setState] = useState(initialState);

  useEffect(() => {
    const fetchDefaultCompanyDetails = async () => {
      if (defaultCompany) {
        try {
          const details = await getCompany(defaultCompany);
          setState((prevState) => ({
            ...prevState,
            selectedCompany: details,
          }));
        } catch (error) {
          console.error(error);
        }
      }
    };
    fetchDefaultCompanyDetails();
  }, [defaultCompany]);

  useEffect(() => {
    const fetchCompanyRole = async () => {
      try {
        const companyRole = await getCompanyRole(state.selectedCompany.uuid);
        setState((prevState) => ({
          ...prevState,
          selectedCompanyRole: companyRole,
        }));
      } catch {
        resetState();
      }
    };

    if (state?.selectedCompany?.uuid) {
      setDefaultCompanyUuid(state.selectedCompany.uuid);
      fetchCompanyRole();
    }
  }, [state.selectedCompany]);

  const resetState = () => {
    setState(initialState);
    setDefaultCompanyUuid(null);
  };

  const contextValue = useMemo(
    () => ({ state, setState, resetState }),
    [state, resetState],
  );

  return (
    <GlobalContext.Provider value={contextValue}>
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobalContext = () => useContext(GlobalContext);
